import {
  SET_WORKSPACE_FOR_EDIT,
  RESET_STATE_WORKSPACE_CREATE_UPDATE,
  WORKSPACE_CREATE_UPDATE_START,
  WORKSPACE_CREATE_UPDATE_FAIL,
  WORKSPACE_CREATE_UPDATE_SUCCESS,
  SET_FIELD,
  RESET_WS_CREATE_ERROR,
  SET_PENDING_WORKSPACE_UPDATE,
  SET_SHOW_GROUPING_CONFIRM
} from 'Screens/Contextualization/Workspaces/actions/Actions';

import {
  SET_FIELD_NAME_HOST_CREATE_UPDATE
} from 'store/HostEditCreate/types';

const initialState = {
  id: null,
  name: '',
  description: '',
  start: '',
  end: '',
  scope: [],
  isFetching: false,
  errorMessage: '',
  redirect: false,
  makePublic: false,
  users: [],
  currentName: '',
  workspaceSaved: false,
  groupby: 'none',
  matchPrecision: 80,
  groupAlgorithm: 'levenshtein',
  pendingWorkspaceUpdate: null,
  showGroupingConfirm: false
};

function workspaceEditCreate (state = initialState, action) {
  switch (action.type) {
    case SET_FIELD: {
      return {
        ...state,
        [action.field]: action.value
      };
    }

    case RESET_STATE_WORKSPACE_CREATE_UPDATE: {
      return {
        ...initialState
      };
    }

    case SET_FIELD_NAME_HOST_CREATE_UPDATE: {
      return {
        ...state,
        [action.fieldName]: action.value
      };
    }

    case WORKSPACE_CREATE_UPDATE_START: {
      return {
        ...state,
        isFetching: true
      };
    }

    case WORKSPACE_CREATE_UPDATE_FAIL: {
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
        workspaceSaved: false
      };
    }

    case WORKSPACE_CREATE_UPDATE_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        workspaceSaved: true
      };
    }

    case SET_WORKSPACE_FOR_EDIT: {
      return {
        ...state,
        ...action.workspace,
        currentName: action.workspace.name,
        start: action.workspace.duration.start_date ? new Date(action.workspace.duration.start_date) : '',
        end: action.workspace.duration.end_date ? new Date(action.workspace.duration.end_date) : '',
        makePublic: action.workspace.public,
        originalGroupBy: action.workspace.groupby,
        originalMatchPrecision: action.workspace.matchPrecision,
        groupby: action.workspace.group_by ?? 'none',
        matchPrecision: action.workspace.group_threshold ?? 80,
        groupAlgorithm: action.workspace.group_algorithm ?? 'levenshtein'
      };
    }

    case RESET_WS_CREATE_ERROR: {
      return {
        ...state,
        errorMessage: '',
        error: false
      };
    }

    case SET_PENDING_WORKSPACE_UPDATE:
      return { ...state, pendingWorkspaceUpdate: action.payload };

    case SET_SHOW_GROUPING_CONFIRM:
      return { ...state, showGroupingConfirm: action.value };

    default:
      return state;
  }
}

export default workspaceEditCreate;
